export default "__VITE_ASSET__CjtR1WBP__"